import request from "../../utils/fetch";

export const getSubscription = (id) => request.get(`subscription/plans?company=${id.id}&sort=-lastModified`);
export const getSubscriptionByID = (id) => request.get(`subscription/plans/${id}`);
export const createOrder = (postData) => request.post("subscription/orders", postData);
export const createPaymentIntent = (items) => request.post(`subscription/orders`, items);
export const getPriceById = (data) => request.get(`subscription/plans/prices/${data}`);
